.navbar {
  height: calc(100dvh - 2 * var(--mantine-spacing-xs));
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: var(--mantine-spacing-xs);
  transition:
    width 0.2s ease-in-out,
    margin-left 0.1s ease-in-out 0.1s;
  background-color: var(--mantine-color-body);

  &[data-collapsed] {
    margin-left: 0;
    overflow: hidden;
  }
}

.navbar__overlay {
  display: none;
}

@media (max-width: 768px) {
  .navbar {
    height: 100dvh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--mantine-z-index-modal);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-xs)
      var(--mantine-spacing-xs) 0;
    border-right: 1px solid var(--theme-color-content-outline);

    &[data-collapsed] {
      margin-left: calc(var(--mantine-spacing-xs) * -2);
    }
  }

  .navbar__overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    z-index: calc(var(--mantine-z-index-modal) - 1);
  }
}

.navbar__content {
  width: 100%;
  height: 100%;
}

.navbar:not([data-collapsed]) .navbar__header {
  height: 44px;
}
